module.exports = __webpack_public_path__ + "img/TV_clean_box20.fd824d8d.jpg";